import { ButtonScrollTop, GenericModal, Loader, PhotosViewer } from '@/components/custom';
import { AppErrorApiServerDisconnected, AppHeader } from './components';
import { useAppInitialisation } from './hooks';
import AppRoutes from './AppRoutes';

const App = () => {

	const { status } = useAppInitialisation();

	if (status === 'isLoading') {
		return <Loader className='my-10' />;
	}

	if (status === 'errorApiServerDisconnected') {
		return <AppErrorApiServerDisconnected />
	}

	return (
		<div className='h-screen flex flex-col space-y-3'>
			<AppHeader />
			<main className='h-full'>
				<AppRoutes />
				<GenericModal />
				<ButtonScrollTop />
				<PhotosViewer />
			</main>
		</div>
	);

};

export default App;
